import icon from '../images/app-icon.png';
import AppStoreBadge from './AppStoreBadge';

export default function Navbar() {
  return (
    <header className="nav">
      <div className="container">
        <div className="nav-inner">
          <a className="brand" href="#top">
            <img src={icon} alt="Klingua app icon" />
            Klingua
          </a>
          <nav className="nav-links">
            <a href="#features">Features</a>
            <a href="#how">How it works</a>
            <a href="#languages">Languages</a>
          </nav>
          <AppStoreBadge />
        </div>
      </div>
    </header>
  );
}
